import React, { useState, useEffect } from "react";
import {
  FaCalendarAlt,
  FaChevronRight,
  FaRegClock,
  FaTags,
  FaUserTie,
} from "react-icons/fa";
import { Link, Navigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";

// Définition des couleurs principales
// Vert June et Rouge pour la charte graphique
const colors = {
  juneGreen: "#6BAA75", // Vert June
  lightGreen: "#8CC49A",
  veryLightGreen: "#EDF7EE",
  red: "#E94E4D", // Rouge
  lightRed: "#F7A0A0",
  darkGray: "#333333",
  lightGray: "#F5F5F5",
  white: "#FFFFFF",
};

// Articles du blog (normalement, ces données viendraient d'une API)
const BlogPosts = [
  {
    id: 1,
    title: "Votre guide pour saisir les opportunités au Bénin",
    excerpt:
      "Découvrez les opportunités exceptionnelles offertes par l'écosystème béninois : ADPME, PSIE, Label Start Up et Sèmè City. Un guide complet pour structurer votre entreprise et bénéficier des programmes de soutien.",
    categories: ["Finance", "Conseil"],
    tags: ["TPE", "PME", "Optimisation fiscale"],
    date: "22 Septembre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-comptable",
    readTime: "8 min",
    image: "../assets/images/blog1.jpg",
    featured: true,
  },
  {
    id: 2,
    title:
      "Maitrisez-vous le nouveau Système Comptable des Entités à But Non Lucratif (SYSCEBNL) ?",
    excerpt:
      "Une révolution silencieuse pour les associations et ONG. Depuis le 1er janvier 2024, le SYSCEBNL transforme la comptabilité des entités à but non lucratif dans l'espace OHADA. Découvrez les enjeux et les risques de non-conformité.",
    categories: ["Comptabilité", "Gestion"],
    tags: ["Erreurs courantes", "Conformité"],
    date: "22 Septembre2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-comptable",
    image: "../assets/images/blog2.jpg",
    featured: true,
  },
  {
    id: 3,
    title:
      "Digitalisation Fiscale au BENIN: Maitrisez la plateforme E-services et securisez votre entreprise",
    excerpt:
      "La fin du papier, le début de l'efficacité. L'époque des longues files d'attente aux guichets des impôts et des déclarations papier est en train de se terminer au Bénin. Découvrez comment maîtriser e-Services et transformer cette obligation en avantage concurrentiel.",
    categories: ["Comptabilité", "Formation"],
    tags: ["Solutions Informatiques", "Analyse financière"],
    date: "22 Septembre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-comptable",
    readTime: "10 min",
    image: "../assets/images/blog3.jpg",
    featured: true,
  },
  {
    id: 4,
    title: "Opérations de fusion : Sécurisez votre croissance",
    excerpt:
      "La fusion est l'opération par laquelle deux ou plusieurs sociétés se réunissent pour n'en former qu'une seule. Découvrez comment votre expert-comptable peut vous accompagner dans ces opérations stratégiques complexes.",
    categories: ["RSE", "Conseils"],
    tags: ["Solutions Informatiques", "Analyse financière"],
    date: "24 Septembre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-comptable",
    readTime: "10 min",
    image: "../assets/images/blog4.jpg",
    featured: true,
  },
  {
    id: 5,
    title: "Dépréciation des immobilisations : Guide complet OHADA",
    excerpt:
      "Cet article rappelle les dispositions et les prescriptions de l'Acte uniforme relatif au droit comptable et à l'information financière sur les procédures qu'une entité doit appliquer pour s'assurer que ses immobilisations incorporelles et corporelles sont comptabilisées pour une valeur qui n'excède pas leur valeur actuelle.",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "24 Septembre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog5.jpg",
    featured: true,
  },
  {
    id: 6,
    title: "Fiscalité des Hydrocarbures au Bénin",
    excerpt:
      "Le Guide de l'Expert-Comptable pour Distributeurs et Gérants de Stations-Service.",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog6.jpg",
    featured: true,
  },
  {
    id: 7,
    title: "Avantages en nature: quel impact sur votre salaire?",
    excerpt:
      "Comment passe-t-on du salaire brut convenu au montant net effectivement perçu ? Quelles sont les retenues obligatoires. ?",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog7.jpg",
    featured: true,
  },
  {
    id: 8,
    title: "Société Civile au Bénin : Quel Régime Fiscal Choisir ? ",
    excerpt:
      "Chez CINEF-EXPERTISE COMPTABLE nous vous éclairons sur les règles applicables en nous basant sur le Code Général des Impôts. Comprendre la fiscalité de votre société civile est la première étape pour prendre des décisions éclairées et optimiser votre situation.",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog8.jpg",
    featured: true,
  },
  {
    id: 9,
    title: "Redressement Fiscal : Comprendre, Anticiper et se Défendre",
    excerpt:
      "Les experts-comptables accompagnent quotidiennement les entreprises dans le pilotage de leurs obligations. Notre objectif avec ce guide est de démystifier le redressement fiscal, de vous en expliquer les étapes clés conformément au Code Général des Impôts (CGI) du Bénin, et surtout, de vous donner les clés pour l'anticiper et y faire face sereinement.",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog9.jpg",
    featured: true,
  },
  {
    id: 10,
    title: "Rémunérations Exceptionnelles au Bénin :Le Guide de votre Expert-Comptable pour Maîtriser l'Impôt sur les Primes et Indemnités",
    excerpt:
      "En tant que dirigeant de PME, vous savez que la reconnaissance du travail de vos collaborateurs passe souvent par des gratifications : 13ème mois, primes de départ, indemnités de fin de carrière... ",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog10.jpg",
    featured: true,
  },
  {
    id: 11,
    title: "Recouvrement de vos Créances: Le Guide Pratique de votre Expert-Comptable ",
    excerpt:
      "A CINEF-EXPERTISE COMPTABLE, nous savons que chaque franc compte pour votre croissance. C'est pourquoi nous vous proposons ce guide pratique pour comprendre et maîtriser le recouvrement de vos créances commerciales, en conformité avec les dispositions de l'OHADA notamment l'Acte Uniforme portant Organisation des Procédures Simplifiées de Recouvrement et des Voies d'Exécution (AUPSRVE).",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "11 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog11.jpg",
    featured: true,
  },
  {
    id: 12,
    title: "Apports en Capital dans l'espace OHADA.Maîtrisez les règles pour chaque type de société (SNC, SCS, SARL, SA, SAS)",
    excerpt:
      "En tant que cabinet d'expertise comptable, CINEF EXPERTISE a conçu ce guide complet pour éclairer votre parcours. ",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "11 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/image29.jpg",
    featured: true,
  },
  
  {
    id: 13,
    title: "Nouvelle Loi sur les Associations et Fondations au Bénin : Ce que vous devez savoir pour assurer votre conformité",
    excerpt:
      "Pour les milliers d'associations, d'ONG et de fondations qui animent la société civile béninoise, cette loi introduit des changements majeurs. Loin d'être une contrainte, elle représente une opportunité de professionnaliser sa gestion et de renforcer sa crédibilité. ",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "11 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog12.jpg",
    featured: true,
  },
  {
    id: 14,
    title: "Nouvelle Loi sur la Concurrence au Bénin : Le Décryptage de votre Expert-Comptable pour Protéger et Développer votre Entreprise",
    excerpt:
      "En tant qu'expert-comptable, au cœur de la stratégie et de la gestion quotidienne des entreprises, il m'apparaît essentiel de vous en présenter les grands axes. Loin d'être une source de contraintes, cette loi est une opportunité de sécuriser vos pratiques commerciales, de renforcer votre compétitivité et d'opérer dans un marché plus sain et plus juste. ",
    categories: ["Comptabilité", "Formation"],
    tags: ["Analyse financière"],
    date: "11 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/image20.png",
    featured: true,
  },
  {
    id: 15,
    title: "Assurance Maladie Obligatoire (AMO) au BÉNIN : ce que le décret 2025-672 change pour votre entreprise et vos salariés",
    excerpt:
      "Les employeurs du secteur privé et les organismes publics à caractère commercial sont tenus de souscrire obligatoirement une police d'assurance maladie couvrant au minimum le panier de soins de base pour leurs salariés, ainsi que pour leurs conjoints et leurs enfants à charge. ",
    categories: ["Assurances", "Finance d'entreprise"],
    tags: ["Finance d'entreprise"],
    date: "08 Décembre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable",
    readTime: "10 min",
    image: "../assets/images/blog15.jpg",
    featured: true,
  },

];

// Catégories pour le filtre
const Categories = [
  "Toutes",
  "Comptabilité",
  "Fiscalité",
  "Finance",
  "Innovation",
  "RSE",
  "Stratégie",
  "Entrepreneuriat",
];

// Liste des auteurs récurrents
const Experts = [
  {
    name: "Wilfrid DEDJI",
    title: "Expert-comptable",
    bio: "Spécialisée en fiscalité des PME et startups",
    articles: 5,
  },
  {
    name: "Guillame GNITIN",
    title: "Comptable chez CINEF-EC",
    bio: "",
    articles: 1,
  },
];

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Toutes");
  const [filteredPosts, setFilteredPosts] = useState(BlogPosts);
  const [subscriberEmail, setSubscriberEmail] = useState("");
  const [postsPerPage, setPostsPerPage] = useState(6);

  useEffect(() => {
    // Filtrer les articles en fonction de la recherche et de la catégorie
    const filtered = BlogPosts.filter((post) => {
      const matchesSearch =
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory =
        selectedCategory === "Toutes" ||
        post.categories.includes(selectedCategory);
      return matchesSearch && matchesCategory;
    });

    setFilteredPosts(filtered);
  }, [searchTerm, selectedCategory]);

  const handleSubmitNewsletter = (e) => {
    e.preventDefault();
    alert(`Email ${subscriberEmail} inscrit à la newsletter avec succès!`);
    setSubscriberEmail("");
  };

  const loadMorePosts = () => {
    setPostsPerPage((prev) => prev + 3);
  };

  return (
    <>
      <Header />

      <div style={{ fontFamily: "'Inter', sans-serif" }}>
        {/* Hero Section moderne et original */}
        <section
          style={{
            background: `linear-gradient(135deg, ${colors.veryLightGreen}, ${colors.white})`,
            padding: "80px 0 120px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Formes décoratives */}
          <div
            style={{
              position: "absolute",
              top: "10%",
              right: "5%",
              width: "300px",
              height: "300px",
              borderRadius: "50%",
              background: `linear-gradient(45deg, ${colors.lightGreen}22, ${colors.veryLightGreen}22)`,
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              bottom: "5%",
              left: "10%",
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              background: `linear-gradient(45deg, ${colors.lightRed}22, ${colors.lightRed}11)`,
              zIndex: 1,
            }}
          ></div>

          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6" style={{ zIndex: 2 }}>
                <div style={{ maxWidth: "540px" }}>
                  <span
                    style={{
                      color: colors.red,
                      fontWeight: 600,
                      fontSize: "16px",
                      display: "inline-block",
                      marginBottom: "16px",
                    }}
                  >
                    NOTRE BLOG D'EXPERTISE
                  </span>

                  <h1
                    style={{
                      fontSize: "48px",
                      fontWeight: 700,
                      marginBottom: "24px",
                      color: colors.darkGray,
                      lineHeight: 1.2,
                    }}
                  >
                    Décryptage et{" "}
                    <span style={{ color: colors.juneGreen }}>conseils</span>{" "}
                    d'experts en comptabilité
                  </h1>

                  <p
                    style={{
                      fontSize: "18px",
                      marginBottom: "32px",
                      color: "#555",
                      lineHeight: 1.6,
                    }}
                  >
                    Découvrez nos analyses, guides pratiques et conseils pour
                    optimiser la gestion financière et comptable de votre
                    entreprise.
                  </p>

                  <div>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        marginRight: "12px",
                        color: "#555",
                      }}
                    >
                      Sujets populaires :
                    </span>

                    {["Fiscalité", "Comptabilité", "Finance", "RSE"].map(
                      (topic, index) => (
                        <button
                          key={index}
                          onClick={() => setSelectedCategory(topic)}
                          style={{
                            background:
                              topic === selectedCategory
                                ? colors.juneGreen
                                : "transparent",
                            color:
                              topic === selectedCategory
                                ? "white"
                                : colors.darkGray,
                            border: `1px solid ${
                              topic === selectedCategory
                                ? colors.juneGreen
                                : "#E0E0E0"
                            }`,
                            borderRadius: "50px",
                            padding: "8px 16px",
                            margin: "0 8px 8px 0",
                            fontSize: "14px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {topic}
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-6" style={{ zIndex: 2 }}>
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "500px",
                      height: "320px",
                      borderRadius: "16px",
                      background: colors.lightGray,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      boxShadow: "0 16px 40px rgba(0,0,0,0.08)",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src="../assets/images/image19.png"
                      alt="Blog Hero"
                      style={{ width: "100%" }}
                    />

                    {/* Overlay décoratif */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: `linear-gradient(45deg, ${colors.red}22, transparent)`,
                        mixBlendMode: "multiply",
                      }}
                    ></div>

                    {/* Éléments graphiques flottants */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "-20px",
                        right: "-20px",
                        width: "120px",
                        height: "120px",
                        borderRadius: "24px",
                        background: colors.juneGreen,
                        transform: "rotate(45deg)",
                        opacity: 0.4,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section Articles à la Une */}
        <section
          style={{
            padding: "80px 0",
            background: colors.white,
          }}
        >
          <div className="container">
            <div className="row mb-5">
              <div className="col-lg-8">
                <h2
                  style={{
                    fontSize: "32px",
                    fontWeight: 700,
                    marginBottom: "16px",
                    color: colors.darkGray,
                  }}
                >
                  Articles à la{" "}
                  <span style={{ color: colors.juneGreen }}>Une</span>
                </h2>
                <p style={{ color: "#666", fontSize: "18px" }}>
                  Découvrez nos derniers articles d'expertise
                </p>
              </div>
              <div className="col-lg-4 d-flex justify-content-lg-end align-items-center">
                <Link
                  to="/blog"
                  style={{
                    color: colors.juneGreen,
                    textDecoration: "none",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Voir tous les articles{" "}
                  <FaChevronRight size={12} style={{ marginLeft: "8px" }} />
                </Link>
              </div>
            </div>

            <div className="row">
              {BlogPosts.map((post, index) => (
                <div key={post.id} className="col-lg-4 col-md-6 mb-4">
                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      background: colors.white,
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0,0,0,0.1)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 20px rgba(0,0,0,0.06)";
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          height: "200px",
                          background: `${colors.lightGray}`,
                        }}
                      >
                        <img
                          src={post.image}
                          alt={post.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          top: "16px",
                          left: "16px",
                          display: "flex",
                          gap: "8px",
                        }}
                      >
                        {post.categories.slice(0, 2).map((category, idx) => (
                          <span
                            key={idx}
                            style={{
                              background:
                                idx === 0 ? colors.juneGreen : colors.red,
                              color: colors.white,
                              padding: "4px 12px",
                              borderRadius: "50px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            {category}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div
                      style={{
                        padding: "24px",
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "16px",
                          fontSize: "13px",
                          color: "#777",
                          marginBottom: "16px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FaCalendarAlt
                            size={12}
                            style={{ marginRight: "6px" }}
                          />
                          <span>{post.date}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FaRegClock
                            size={12}
                            style={{ marginRight: "6px" }}
                          />
                          <span>{post.readTime}</span>
                        </div>
                      </div>

                      <h3
                        style={{
                          fontSize: "20px",
                          fontWeight: 700,
                          marginBottom: "12px",
                          lineHeight: 1.3,
                        }}
                      >
                        {post.title}
                      </h3>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#555",
                          lineHeight: 1.6,
                          marginBottom: "24px",
                          flexGrow: 1,
                          textAlign: "justify",
                        }}
                      >
                        {post.excerpt}
                      </p>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingTop: "16px",
                          borderTop: "1px solid #eee",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: "#ccc",
                              marginRight: "12px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: colors.white,
                              fontWeight: 600,
                              fontSize: "14px",
                            }}
                          >
                            {post.author.charAt(0)}
                          </div>
                          <div>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              {post.author}
                            </div>
                            <div style={{ fontSize: "12px", color: "#777" }}>
                              {post.authorTitle}
                            </div>
                          </div>
                        </div>

                        <Link
                          to={`/blog/${post.id}`}
                          style={{
                            color: colors.juneGreen,
                            fontWeight: 600,
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                          }}
                        >
                          Lire{" "}
                          <FaChevronRight
                            size={10}
                            style={{ marginLeft: "6px" }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section filtrage et liste d'articles */}
        <section
          style={{
            padding: "60px 0 80px",
          }}
        >
          <div className="container">
            {/* Barre de filtrage */}
            {/* <div className="row mb-5">
              <div className="col-lg-12">
                <div
                  style={{
                    background: colors.white,
                    padding: "16px 24px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      minWidth: "240px",
                    }}
                  >
                    <select
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "12px",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                      }}
                    >
                      {Categories.map((category, index) => (
                        <option key={index} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    style={{
                      flexGrow: 2,
                      position: "relative",
                      minWidth: "280px",
                    }}
                  >
                    <FaSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#999",
                      }}
                    />
                    <input
                      type="text"
                      placeholder="Rechercher un article..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "12px 12px 12px 40px",
                        fontSize: "14px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div> */}

            <div className="row">
              {/* Articles */}
              {/* <div className="col-lg-8">
                                <div className="row">
                                    {filteredPosts.length > 0 ? (
                                        filteredPosts.slice(0, postsPerPage).map((post, index) => (
                                            <div key={post.id} className="col-md-6 mb-4">
                                                <div style={{
                                                    borderRadius: "10px",
                                                    overflow: "hidden",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                                    background: colors.white,
                                                    height: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    transition: "transform 0.2s ease",
                                                    cursor: "pointer"
                                                }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.transform = "translateY(-4px)";
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                    }}
                                                >
                                                    <div style={{ position: "relative" }}>
                                                        <div style={{ height: "160px", background: colors.lightGray }}>
                                                            <img
                                                                src={post.image}
                                                                alt={post.title}
                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                            />
                                                        </div>
                                                        <div style={{
                                                            position: "absolute",
                                                            bottom: "0",
                                                            left: "0",
                                                            right: "0",
                                                            padding: "12px",
                                                            background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                                                            display: "flex",
                                                            gap: "8px"
                                                        }}>
                                                            {post.categories.slice(0, 1).map((category, idx) => (
                                                                <span
                                                                    key={idx}
                                                                    style={{
                                                                        background: colors.juneGreen,
                                                                        color: colors.white,
                                                                        padding: "3px 10px",
                                                                        borderRadius: "50px",
                                                                        fontSize: "11px",
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    {category}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div style={{
                                                        padding: "16px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        flexGrow: 1
                                                    }}>
                                                        <div style={{
                                                            display: "flex",
                                                            gap: "12px",
                                                            fontSize: "12px",
                                                            color: "#777",
                                                            marginBottom: "10px"
                                                        }}>
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <FaCalendarAlt size={10} style={{ marginRight: "4px" }} />
                                                                <span>{post.date}</span>
                                                            </div>
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <FaRegClock size={10} style={{ marginRight: "4px" }} />
                                                                <span>{post.readTime}</span>
                                                            </div>
                                                        </div>

                                                        <h3 style={{
                                                            fontSize: "16px",
                                                            fontWeight: 600,
                                                            marginBottom: "12px",
                                                            lineHeight: 1.4
                                                        }}>
                                                            {post.title}
                                                        </h3>

                                                        <p style={{
                                                            fontSize: "14px",
                                                            color: "#666",
                                                            lineHeight: 1.5,
                                                            marginBottom: "16px",
                                                            flexGrow: 1
                                                        }}>
                                                            {post.excerpt.length > 100
                                                                ? post.excerpt.substring(0, 100) + "..."
                                                                : post.excerpt}
                                                        </p>

                                                        <div style={{
                                                            fontSize: "13px",
                                                            color: "#555",
                                                            display: "flex",
                                                            justifyContent: "space-between"
                                                        }}>
                                                            <span>Par {post.author}</span>
                                                            <Link to={`/blog/${post.id}`} style={{
                                                                color: colors.juneGreen,
                                                                fontWeight: 600,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                textDecoration: "none"
                                                            }}>
                                                                Lire <FaChevronRight size={8} style={{ marginLeft: "4px" }} />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{
                                            padding: "40px 20px",
                                            textAlign: "center",
                                            background: colors.white,
                                            borderRadius: "10px"
                                        }}>
                                            <div style={{ fontSize: "48px", marginBottom: "16px" }}>🔍</div>
                                            <h3 style={{ marginBottom: "12px" }}>Aucun article trouvé</h3>
                                            <p style={{ marginBottom: "20px", color: "#666" }}>
                                                Essayez de modifier vos critères de recherche ou de filtrage.
                                            </p>
                                            <button
                                                onClick={() => {
                                                    setSearchTerm("");
                                                    setSelectedCategory("Toutes");
                                                }}
                                                style={{
                                                    background: colors.juneGreen,
                                                    color: colors.white,
                                                    border: "none",
                                                    padding: "10px 20px",
                                                    borderRadius: "8px",
                                                    fontWeight: 600,
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Réinitialiser les filtres
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {postsPerPage < filteredPosts.length && (
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginTop: "32px"
                                    }}>
                                        <button
                                            onClick={loadMorePosts}
                                            style={{
                                                background: "transparent",
                                                color: colors.juneGreen,
                                                border: `2px solid ${colors.juneGreen}`,
                                                padding: "12px 24px",
                                                borderRadius: "8px",
                                                fontWeight: 600,
                                                cursor: "pointer",
                                                transition: "all 0.2s ease"
                                            }}
                                            onMouseOver={(e) => {
                                                e.target.style.background = colors.juneGreen;
                                                e.target.style.color = colors.white;
                                            }}
                                            onMouseOut={(e) => {
                                                e.target.style.background = "transparent";
                                                e.target.style.color = colors.juneGreen;
                                            }}
                                        >
                                            Charger plus d'articles
                                        </button>
                                    </div>
                                )}
                            </div> */}

              {/* Sidebar */}
              {/* Section widgets en ligne - Newsletter, Tags, Experts */}
              <div className="col-lg-12">
                <div className="row g-4" style={{ marginBottom: "40px" }}>
                  {/* Widget Newsletter */}
                  <div className="col-lg-4 col-md-6">
                    <div
                      style={{
                        background: colors.white,
                        borderRadius: "12px",
                        padding: "28px",
                        height: "100%",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                        border: "1px solid #f3f4f6",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <h4
                        style={{
                          fontSize: "20px",
                          fontWeight: 700,
                          marginBottom: "16px",
                          color: colors.darkGray,
                          paddingBottom: "12px",
                          borderBottom: `2px solid ${colors.veryLightGreen}`,
                        }}
                      >
                        📧 Newsletter
                      </h4>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#666",
                          marginBottom: "20px",
                          lineHeight: 1.6,
                        }}
                      >
                        Recevez nos derniers articles et conseils directement
                        dans votre boîte mail
                      </p>
                      <form onSubmit={handleSubmitNewsletter}>
                        <input
                          type="email"
                          placeholder="Votre adresse email"
                          value={subscriberEmail}
                          onChange={(e) => setSubscriberEmail(e.target.value)}
                          required
                          style={{
                            width: "100%",
                            padding: "12px",
                            marginBottom: "12px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            fontSize: "14px",
                          }}
                        />
                        <button
                          type="submit"
                          style={{
                            width: "100%",
                            padding: "12px",
                            background: colors.juneGreen,
                            color: colors.white,
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: 600,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                        >
                          S'inscrire
                        </button>
                        <small
                          style={{
                            display: "block",
                            marginTop: "8px",
                            fontSize: "12px",
                            color: "#999",
                            textAlign: "center",
                          }}
                        >
                          Désabonnement possible à tout moment
                        </small>
                      </form>
                    </div>
                  </div>

                  {/* Widget Tags populaires */}
                  <div className="col-lg-4 col-md-6">
                    <div
                      style={{
                        background: colors.white,
                        borderRadius: "12px",
                        padding: "28px",
                        height: "100%",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                        border: "1px solid #f3f4f6",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "16px",
                          paddingBottom: "12px",
                          borderBottom: `2px solid ${colors.veryLightGreen}`,
                        }}
                      >
                        <FaTags
                          size={16}
                          style={{
                            color: colors.juneGreen,
                            marginRight: "12px",
                          }}
                        />
                        <h4
                          style={{
                            fontSize: "20px",
                            fontWeight: 700,
                            margin: 0,
                            color: colors.darkGray,
                          }}
                        >
                          Tags populaires
                        </h4>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        {[
                          "Comptabilité",
                          "Fiscalité",
                          "TPE",
                          "PME",
                          "Auto-entrepreneur",
                          "Audit",
                          "Optimisation fiscale",
                          "Bilan",
                        ].map((tag, index) => (
                          <span
                            key={index}
                            style={{
                              background: "#f0f0f0",
                              color: "#555",
                              padding: "6px 12px",
                              borderRadius: "50px",
                              fontSize: "13px",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              fontWeight: 500,
                            }}
                            onMouseOver={(e) => {
                              e.target.style.background = colors.juneGreen;
                              e.target.style.color = colors.white;
                            }}
                            onMouseOut={(e) => {
                              e.target.style.background = "#f0f0f0";
                              e.target.style.color = "#555";
                            }}
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Widget Nos experts */}
                  <div className="col-lg-4 col-md-12">
                    <div
                      style={{
                        background: colors.white,
                        borderRadius: "12px",
                        padding: "28px",
                        height: "100%",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                        border: "1px solid #f3f4f6",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <h4
                        style={{
                          fontSize: "20px",
                          fontWeight: 700,
                          marginBottom: "16px",
                          color: colors.darkGray,
                          paddingBottom: "12px",
                          borderBottom: `2px solid ${colors.veryLightGreen}`,
                        }}
                      >
                        👥 Nos experts
                      </h4>

                      {Experts.map((expert, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom:
                              index === Experts.length - 1 ? 0 : "16px",
                            padding: "12px",
                            background:
                              index === 0
                                ? colors.veryLightGreen
                                : "transparent",
                            borderRadius: "8px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          <div
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "50%",
                              background:
                                index === 0 ? colors.juneGreen : colors.red,
                              marginRight: "12px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: colors.white,
                              fontWeight: 600,
                              fontSize: "18px",
                              flexShrink: 0,
                            }}
                          >
                            {expert.name.charAt(0)}
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "15px",
                                color: "#333",
                              }}
                            >
                              {expert.name}
                            </div>
                            <div style={{ fontSize: "13px", color: "#777" }}>
                              {expert.title}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section
          style={{
            padding: "60px 0",

            color: colors.black,
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 mb-4 mb-lg-0">
                <h2
                  style={{
                    fontWeight: 700,
                    fontSize: "32px",
                    marginBottom: "16px",
                  }}
                >
                  Besoin d'un expert-comptable pour votre entreprise?
                </h2>
                <p
                  style={{
                    fontSize: "18px",
                    opacity: 0.9,
                    maxWidth: "600px",
                    marginBottom: "24px",
                  }}
                >
                  CINEF-EXPERTISE vous accompagne dans la gestion comptable et
                  fiscale de votre entreprise avec des solutions sur-mesure.
                </p>
                <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                  <Link to="/contact" style={{ textDecoration: "none" }}>
                    <button
                      style={{
                        background: colors.red,
                        color: colors.white,
                        padding: "12px 24px",
                        border: "none",
                        borderRadius: "8px",
                        fontWeight: 600,
                        fontSize: "16px",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      Prendre rendez-vous
                    </button>
                  </Link>
                </div>
              </div>
              <div className="col-lg-5">
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    borderRadius: "12px",
                    padding: "30px",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
                    backdropFilter: "blur(5px)",
                  }}
                >
                  <div
                    style={{
                      background: colors.white,
                      width: "80px",
                      height: "80px",
                      borderRadius: "16px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "24px",
                    }}
                  >
                    <FaUserTie size={36} style={{ color: colors.juneGreen }} />
                  </div>
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: "24px",
                      marginBottom: "16px",
                    }}
                  >
                    CIEF-EC, votre cabinet d'expertise comptable
                  </h3>
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    {["Comptabilité", "Fiscalité", "Conseil", "Audit"].map(
                      (service, index) => (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "12px",
                          }}
                        >
                          <div
                            style={{
                              background: "rgba(255,255,255,0.2)",
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginRight: "12px",
                            }}
                          >
                            <FaChevronRight size={10} />
                          </div>
                          {service}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Blog;
